<!--  -->
<template>
    <transition name="el-fade15">
        <div v-show="pageVisible" class="admin-page-inner">
            <div class="admin-page-content">
                <el-container class="admin-container">
                    <el-header
                        class="admin-header el-clearfix"
                        :height="adminHeaderHeight + 'px'"
                    >
                        <div
                            :class="[
                                'admin-header-aside',
                                { collapsed: aisdeMenuCollapsed }
                            ]"
                            :style="{ width: adminAsideWidth + 'px' }"
                        >
                            <svg class="logo">
                                <use xlink:href="#logo"></use>
                            </svg>
                            <div class="name">{{ adminName }}</div>
                            <!-- <template v-if="loginUser.orgName">
                                <div class="org-name">
                                    {{ loginUser.orgName }}
                                </div>
                                <div class="sys-title">{{ adminName }}</div>
                            </template>
                            <template v-else>
                                <div class="name">{{ adminName }}</div>
                            </template> -->
                        </div>
                        <div
                            class="admin-header-main el-clearfix"
                            :style="{ marginLeft: adminAsideWidth + 'px' }"
                        >
                            <i
                                :class="['admin-header-trigger', triggerClass]"
                                @click="toggleCollapseAsideMenu"
                            ></i>
                            <div class="admin-header-menu">
                                <!-- NavMenuList removed from here -->
                                <el-menu
                                    class="admin-header-menu-tools"
                                    mode="horizontal"
                                    :router="false"
                                >
                                    <el-menu-item index="1" class="notices">
                                        <i
                                            class="far fa-bell"
                                            title="消息通知"
                                        ></i>
                                        <el-badge
                                            v-if="loginUser.noticeBadges > 0"
                                            :value="loginUser.noticeBadges"
                                        ></el-badge>
                                    </el-menu-item>
                                    <el-menu-item index="2" class="questions"
                                        ><i
                                            class="far fa-question-circle"
                                            title="帮助说明"
                                        ></i
                                    ></el-menu-item>
                                    <el-menu-item index="3" class="loginuser">
                                        <el-dropdown
                                            placement="bottom-start"
                                            @command="handleDropdownCommand"
                                        >
                                            <span class="loginuser-name"
                                                ><img
                                                    :src="loginUser.userIconUrl"
                                                />
                                                {{ loginUser.nickName }}</span
                                            >
                                            <el-dropdown-menu
                                                slot="dropdown"
                                                class="loginuser-menus"
                                            >
                                                <el-dropdown-item
                                                    command="goToUserHome"
                                                >
                                                    <i
                                                        class="far fa-user-circle"
                                                    ></i>
                                                    个人中心
                                                </el-dropdown-item>
                                                <el-dropdown-item
                                                    command="goToUserSettings"
                                                >
                                                    <i class="fas fa-cog"></i>
                                                    个人设置
                                                </el-dropdown-item>
                                                <el-dropdown-item
                                                    command="goToAccessLog"
                                                >
                                                    <i
                                                        class="fas fa-history"
                                                    ></i>
                                                    操作日志
                                                </el-dropdown-item>
                                                <el-dropdown-item
                                                    command="goToFiles"
                                                >
                                                    <i
                                                        class="el-icon-files"
                                                    ></i>
                                                    相关文件
                                                </el-dropdown-item>
                                                <el-dropdown-item
                                                    divided
                                                    command="logoutAccount"
                                                >
                                                    <i
                                                        class="el-icon-switch-button"
                                                    ></i>
                                                    账号注销
                                                </el-dropdown-item>
                                                <el-dropdown-item
                                                    divided
                                                    command="execUserLogout"
                                                >
                                                    <i
                                                        class="fas fa-sign-out-alt"
                                                    ></i>
                                                    退出登录
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </el-menu-item>
                                    <el-menu-item
                                        index="4"
                                        class="logout"
                                        @click="handleLogoutClick"
                                        ><i
                                            class="fas fa-power-off"
                                            title="退出"
                                        ></i
                                    ></el-menu-item>
                                </el-menu>
                            </div>
                        </div>
                    </el-header>
                    <el-container
                        :style="{
                            height: windowHeight - adminHeaderHeight + 'px'
                        }"
                    >
                        <el-aside
                            class="admin-aside"
                            :width="adminAsideWidth + 'px'"
                        >
                            <el-scrollbar
                                wrap-class="admin-scrollbar"
                                :wrap-style="adminScrollbarStyles"
                            >
                                <admin-aside-menu
                                    :default-active="asideMenuActive"
                                    :default-openeds="asideMenuOpeneds"
                                    :menu-list="asideMenuList"
                                    :menu-class="asideMenuClass"
                                    :popper-menu-class="asidePopperMenuClass"
                                    :collapsed="aisdeMenuCollapsed"
                                    @select="onAsideMenuSelected"
                                ></admin-aside-menu>
                                <!-- <router-link :to="{path: '/useragreement.html'}" class="admin-aside-bottom">机动车综合服务平台用户协议</router-link> -->
                                <a
                                    href="https://file.ht-insurance.com/20260814/51ae140a326b4e82ad6b6a6c289c754c.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="admin-aside-bottom"
                                >
                                    机动车综合服务平台用户协议
                                </a>
                            </el-scrollbar>
                        </el-aside>
                        <el-main class="admin-main">
                            <el-scrollbar
                                wrap-class="admin-scrollbar"
                                :wrap-style="adminScrollbarStyles"
                            >
                                <div class="admin-main-wrap">
                                    <slot></slot>
                                </div>
                            </el-scrollbar>
                        </el-main>
                    </el-container>
                </el-container>
            </div>
            <el-dialog
                title="相关文件"
                width="400px"
                :visible.sync="dialogFilesVisible"
            >
                <div class="files-box">
                    <a
                        href="https://file.ht-insurance.com/20260814/51ae140a326b4e82ad6b6a6c289c754c.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        《用户协议》
                    </a>
                    <a
                        href="https://file.ht-insurance.com/20260814/e44afa89bbfb4b14a0ed8f676b691bb7.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        《隐私政策》
                    </a>
                    <a
                        href="https://file.ht-insurance.com/20260814/94727304ab47499db835d491ca6be137.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        《敏感个人信息收集处理授权书》
                    </a>
                </div>
            </el-dialog>
        </div>
    </transition>
</template>

<script>
import '@/assets/svg/logo.svg';

import { WINDOW_HEIGHT, ADMIN_HEADER_HEIGHT } from '@/constants.js';

import AdminAsideMenu from './admin-aside-menu.js';

/**
 * 侧边导航菜单栏收缩/展开状态KEY
 */
const ADMIN_ASIDE_MENU_COLLAPSE_STATE_KEY =
    'ADMIN_ASIDE_MENU_COLLAPSE_STATE_KEY';

export default {
    name: 'AdminContainer',

    components: {
        AdminAsideMenu
    },

    props: {
        adminName: {
            type: String,
            default: 'XAdmin Pro'
        },
        adminLogoIcon: {
            type: String,
            default: 'fas fa-dice-d6'
        },
        adminVersion: {
            type: String,
            default: 'V1.0.0'
        },
        allDataReady: {
            type: Boolean,
            default: false
        },
        pageLoadingTimeout: {
            type: Number,
            default: 1500
        },
        loginUser: {
            type: Object,
            default() {
                return {};
            }
        },
        asideMenuWidth: {
            type: Number,
            default: 240
        },
        asideMenuList: {
            type: Array,
            default() {
                return [];
            }
        },
        asideMenuActive: String,
        asideMenuOpeneds: {
            type: Array,
            default() {
                return [];
            }
        },
        asideMenuClass: {
            type: String,
            default: 'el-menu-vertical-dark'
        },
        asidePopperMenuClass: {
            type: String,
            default: 'el-menu-vertical-dark'
        }
    },

    data() {
        return {
            pageVisible: false,
            pageLoadingStartTime: 0,
            aisdeMenuCollapsed: false,
            windowHeight: WINDOW_HEIGHT,
            adminHeaderHeight: ADMIN_HEADER_HEIGHT,
            adminScrollbarStyles: [
                { maxHeight: WINDOW_HEIGHT - ADMIN_HEADER_HEIGHT + 'px' }
            ],
            dialogFilesVisible: false
        };
    },

    computed: {
        triggerClass() {
            return this.aisdeMenuCollapsed ? 'fas fa-indent' : 'fas fa-outdent';
        },
        adminAsideWidth() {
            return this.aisdeMenuCollapsed ? 64 : this.asideMenuWidth;
        }
    },

    created() {
        this.initMenuCollapseState();
        this.beforePageLoading();
    },

    mounted() {},

    methods: {
        initMenuCollapseState() {
            let sessionAsideMenuCollapsed = sessionStorage.getItem(
                ADMIN_ASIDE_MENU_COLLAPSE_STATE_KEY
            );
            this.aisdeMenuCollapsed = sessionAsideMenuCollapsed
                ? sessionAsideMenuCollapsed === 'true'
                    ? true
                    : false
                : false;
        },
        beforePageLoading() {
            this.$Progress.start(); //开始Loading效果
            this.pageLoadingStartTime = new Date().getTime();
        },
        handlePageLoading() {
            if (this.pageLoadingTimeout <= 0) {
                //按实际加载时间来执行loading效果
                this.afterPageLoading();
            } else {
                let pageLoadingEndTime = new Date().getTime();
                let dataLoadingTime =
                    pageLoadingEndTime - this.pageLoadingStartTime;
                let remainLoadingTime =
                    this.pageLoadingTimeout - dataLoadingTime;
                if (remainLoadingTime <= 0) {
                    this.afterPageLoading();
                } else {
                    //console.log('remainLoadingTime = ' + remainLoadingTime);
                    setTimeout(() => {
                        this.afterPageLoading();
                    }, remainLoadingTime);
                }
            }
        },
        afterPageLoading() {
            this.$Progress.finish();
            this.pageVisible = true;
        },
        onAsideMenuSelected(index, indexPath) {
            this.$emit('aside-menu-selected', index, indexPath);
        },
        toggleCollapseAsideMenu: function() {
            this.aisdeMenuCollapsed = !this.aisdeMenuCollapsed;
            sessionStorage.setItem(
                ADMIN_ASIDE_MENU_COLLAPSE_STATE_KEY,
                this.aisdeMenuCollapsed
            );
        },
        handleDropdownCommand(command) {
            if (command == 'execUserLogout') {
                this.handleLogoutClick();
            } else if (command == 'goToUserHome') {
                this.$router.push({ name: 'UpmsUserHome' });
            } else if (command == 'goToUserSettings') {
                this.$router.push({ name: 'UpmsUserSettings' });
            } else if (command == 'goToAccessLog') {
                this.$router.push({ name: 'UpmsUserAccessLog' });
            } else if (command == 'goToFiles') {
                this.dialogFilesVisible = true;
            } else if (command == 'logoutAccount') {
                this.cancelAccount();
            }
        },
        handleLogoutClick() {
            this.$emit('logout');
        },
        cancelAccount() {
            this.$emit('cancelAccount');
        }
    },

    watch: {
        allDataReady(newVal, oldVal) {
            if (newVal) {
                //所有数据都加载完了，结束loading效果
                this.handlePageLoading();
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.org-name {
    height: 30px;
    line-height: 48px;
    font-size: 12px;
    overflow: hidden;
    padding: 0;
    margin: 0;
    margin-left: 50px;
    box-sizing: border-box;
    font-weight: bold;
    font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
    color: #fff;
    text-align: left;
    padding-left: 10px;
}
.sys-title {
    height: 30px;
    line-height: 24px;
    font-size: 12px;
    overflow: hidden;
    padding: 0;
    margin: 0;
    margin-left: 50px;
    box-sizing: border-box;
    font-weight: bold;
    font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
    color: #fff;
    text-align: left;
    padding-left: 10px;
}
.files-box {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-bottom: 20px;
}
</style>
